var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[(this.$route.path !== '/')?_c('v-app-bar',{attrs:{"flat":"","max-height":"65"}},[_c('Header')],1):_vm._e(),_c('router-view'),(this.$route.path !== '/')?_c('v-footer',[_c('Footer')],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }